import React from "react";
import * as R from "ramda";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import moment from "moment";

import * as a from "./action";
import * as t from "./thunk";
import { DataTable } from "../DataComponents";
import { round } from "../Utilities";
const componentTransformer = R.compose(
  connect(
    (state) => state.liabilities,
    (dispatch) => bindActionCreators({ ...a, ...t }, dispatch)
  )
);

class LiabilitiesTable extends React.Component {
  async componentDidMount() {
    await this.props.fetchLiabilities();
  }

  componentWillUnmount() {
    this.props.clearLiabilities();
  }

  render() {
    return (
      <DataTable
        defaultSortBy="liabilityDate"
        defaultSortDirection="down"
        dataName="Liabilities"
        data={this.props.items}
        columns={this.columns}
        dataTransformer={this.dataTransformer}
      />
    );
  }

  dataTransformer = ({ ...liabilities }) => ({
    liabilityDate: moment(liabilities.liabilityDate).format("MM/DD/YYYY"),
    cardId: liabilities.cardId,
    orderId: liabilities.orderId,
    merchant: liabilities.merchant,
    liabilityAmount: round.format(liabilities.liabilityAmount),
    externalCardID: liabilities.externalCardID,
    liabilityStatus: liabilities.liabilityStatus,
    liabilityReason: liabilities.liabilityReason,
    reasonDetails: liabilities.reasonDetails,
    number: liabilities.number,
    deductionDate:
      liabilities.liabilityStatus !== "pending"
        ? moment(liabilities.deductionDate).format("MM/DD/YYYY")
        : "TBD",
  });

  // TODO: Move this to the store to make the columns movable.
  get columns() {
    return [
      { label: "Date", dataKey: "liabilityDate" },
      { label: "Order ID", dataKey: "orderId" },
      { label: "Card ID", dataKey: "cardId", numeric: true, alignRight: true },
      { label: "Merchant", dataKey: "merchant" },
      { label: "Amount", dataKey: "liabilityAmount", numeric: true },
      { label: "Card Number", dataKey: "number" },
      { label: "Status", dataKey: "liabilityStatus" },
      { label: "Reason", dataKey: "liabilityReason" },
      { label: "Details", dataKey: "reasonDetails" },
      { label: "Deduction Date", dataKey: "deductionDate" },
    ];
  }
}

LiabilitiesTable = componentTransformer(LiabilitiesTable);

export { LiabilitiesTable };
